import __base_store from '@/store/__base_store'

/**
 * Store de alcances de vinculación de inventario (modelo `inventory_linkage_scope`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'inventory_linkage_scope',
	},
})

